export enum SNCDashboardCompareDateRange {
    Last7DaysDescription = 'Last 7 Days',
    Last7Days = 1,
    Last30DaysDescription = 'Last 30 Days',
    Last30Days = 2,
    Last3MonthsDescription = 'Last 3 Months',
    Last3Months = 3,
    Last6MonthsDescription = 'Last 6 Months',
    Last6Months = 4,
    CustomDescription = 'Custom',
    Custom = 5,
}
